import { render, staticRenderFns } from "./addModel.vue?vue&type=template&id=0283f560&scoped=true"
import script from "./addModel.vue?vue&type=script&lang=js"
export * from "./addModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0283f560",
  null
  
)

export default component.exports